// Mock data for ALMEEAD ALRASEKH Auto Parts Company

export const companyInfo = {
  name: "الميعاد الراسخ لاستيراد وسائل النقل وملحقاتها",
  nameEnglish: "ALMEEAD ALRASEKH",
  tagline: "شريكك الموثوق في قطع غيار السيارات",
  description: "نحن شركة متخصصة في توفير قطع غيار أصلية وعالية الجودة لجميع أنواع السيارات. نفخر بخدمة عملائنا في ليبيا منذ سنوات عديدة بمنتجات موثوقة وأسعار تنافسية.",
  phone: "+218 91 495 9518",
  email: "info@almeead.ly",
  address: "زليتن، طريق الساحلي",
  workingHours: "السبت - الخميس: 8:00 ص - 6:00 م"
};

export const carBrands = [
  {
    id: 1,
    name: "هونداي HD65",
    nameEnglish: "Hyundai HD65",
    description: "قطع غيار أصلية لشاحنات هونداي HD65 المبردة",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/yoorlyq8_IMG_6547.jpeg"
  },
  {
    id: 2,
    name: "هونداي بورتر",
    nameEnglish: "Hyundai Porter",
    description: "قطع غيار أصلية لشاحنات هونداي بورتر",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/yqa3umeb_IMG_6550.jpeg"
  },
  {
    id: 3,
    name: "كيا بونقو",
    nameEnglish: "Kia Bongo",
    description: "قطع غيار عالية الجودة لشاحنات كيا بونقو",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/z5ort9nn_IMG_6552.jpeg"
  },
  {
    id: 4,
    name: "كيا فرسان",
    nameEnglish: "Kia Frontier",
    description: "قطع غيار معتمدة لشاحنات كيا فرسان",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/8g068ltj_IMG_6551.jpeg"
  },
  {
    id: 5,
    name: "كيا بريجيو",
    nameEnglish: "Kia Pregio",
    description: "قطع غيار أصلية لباصات كيا بريجيو",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/3r15pafw_IMG_6561.jpeg"
  },
  {
    id: 6,
    name: "هونداي HD72",
    nameEnglish: "Hyundai HD72",
    description: "قطع غيار أصلية لشاحنات هونداي HD72",
    image: "https://customer-assets.emergentagent.com/job_almeead-alrasekh/artifacts/qicghdxw_IMG_6562.png"
  }
];

export const services = [
  {
    id: 1,
    title: "قطع غيار أصلية",
    description: "نوفر قطع غيار أصلية ومعتمدة من الوكلاء الرسميين"
  },
  {
    id: 2,
    title: "جودة عالية",
    description: "جميع منتجاتنا تخضع لفحص الجودة الصارم"
  },
  {
    id: 3,
    title: "أسعار تنافسية",
    description: "أفضل الأسعار في السوق الليبي"
  },
  {
    id: 4,
    title: "توصيل سريع",
    description: "خدمة توصيل سريعة لجميع المدن الليبية"
  }
];

export const features = [
  "خبرة طويلة في مجال قطع غيار السيارات",
  "شبكة واسعة من الموردين المعتمدين",
  "ضمان على جميع المنتجات",
  "فريق دعم فني محترف",
  "مخزون كبير ومتنوع"
];